import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { USER_LOCALSTORAGE_KEY } from "shared/const/localstorage";

import {TestApiResponse} from "../../types/test/TestSchema";
import {setTests} from "../../slice/test/testSlice";
import {setTeacherTests} from "../../slice/test/test-teacher/testTeacherSlice";
import {clearTestState} from "features/model/slice/test/get-test/getTestSlice";
import {resetCorrectTestCount} from "features/model/slice/test/correct-test/correctTestSlice";


interface TestSearchParams {
    sort?: string;
    search?: string;
    my_tests?: number;
    from?: string;
    to?: string;
    page?: number;
}

export const getTests = createAsyncThunk(
    "tests/fetchTests",
    async (queryParams:TestSearchParams, thunkAPI) => {
        try {
            thunkAPI.dispatch(clearTestState());
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.get<TestApiResponse>("/api/tests", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: queryParams,
            });

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            if (queryParams.my_tests) {
                thunkAPI.dispatch(setTests(response.data));
            } else {
                thunkAPI.dispatch(setTeacherTests(response.data));
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);